import { useEffect, useState } from "react";

export default function AddWorkPage({ categories, onAddWork, onUpdate, onClose, work, activeCategory }) {
  const [formWork, setFormWork] = useState({
    name: "",
    description: "",
    fullDescription: "",
    imageFile: null,
    isActive: true,
  });

  const isEdit = !!work;

  useEffect(() => {
    if (isEdit && work) {
      setFormWork({
        name: work.name || "",
        description: work.description || "",
        fullDescription: work.fullDescription || "",
        imageFile: null,
        isActive: work.isActive !== undefined ? work.isActive : true,
      });
    }
  }, [isEdit, work]);

  const handleSubmit = async () => {
    if (!formWork.name) return;

    const formData = new FormData();
    formData.append("name", formWork.name);
    formData.append("description", formWork.description);
    formData.append("fullDescription", formWork.fullDescription);
    formData.append("is_active", formWork.isActive ? 1 : 0);

    // ✅ append category_id from work or first category if adding new
    const categoryId = work?.category_id ?? activeCategory ?? (categories.length > 0 ? categories[0].id : null);
    if (!categoryId) {
      console.error("No category_id provided");
      return;
    }
    formData.append("category_id", categoryId);

    if (formWork.imageFile) formData.append("image", formWork.imageFile);

    try {
      if (isEdit && onUpdate) {
        await onUpdate(formData, work.id);
      } else {
        await onAddWork(formData);
      }
    } catch (err) {
      console.error("Erreur ajout/modif:", err.response?.data);
      return;
    }

    setFormWork({
      name: "",
      description: "",
      fullDescription: "",
      imageFile: null,
      isActive: true,
    });
    onClose();
  };

  return (
    <div className="add-work-overlay" onClick={onClose}>
      <div className="add-work-panel" onClick={e => e.stopPropagation()}>
        <div className="add-work-header">
          <h2>{isEdit ? "Modifier le travail" : "Ajouter un nouveau travail"}</h2>
          <button className="close-panel-btn" onClick={onClose}>×</button>
        </div>

        <div className="add-work-form-panel">
          <div className="form-group">
            <label>Nom du travail</label>
            <input
              type="text"
              placeholder="Ex: Installation tableau"
              value={formWork.name}
              onChange={e => setFormWork({ ...formWork, name: e.target.value })}
              autoFocus
            />
          </div>

          <div className="form-group">
            <label>Description courte</label>
            <textarea
              placeholder="Description courte..."
              rows="3"
              value={formWork.description}
              onChange={e => setFormWork({ ...formWork, description: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Description longue</label>
            <textarea
              placeholder="Description détaillée..."
              rows="4"
              value={formWork.fullDescription}
              onChange={e => setFormWork({ ...formWork, fullDescription: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Image du travail</label>
            <input
              type="file"
              accept="image/*"
              onChange={e => setFormWork({ ...formWork, imageFile: e.target.files[0] })}
            />
            {(formWork.imageFile || (isEdit && work.image)) && (
              <div style={{
                marginTop: "10px",
                width: "200px",
                height: "200px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                overflow: "hidden"
              }}>
                <img
                  src={formWork.imageFile ? URL.createObjectURL(formWork.imageFile) : work.image}
                  alt="Prévisualisation"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
            )}
          </div>

          <div className="form-group" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <input
              type="checkbox"
              id="isActiveWork"
              checked={formWork.isActive}
              onChange={e => setFormWork({ ...formWork, isActive: e.target.checked })}
              style={{ width: "20px", height: "20px", cursor: "pointer" }}
            />
            <label htmlFor="isActiveWork" style={{ marginBottom: 0, cursor: "pointer" }}>
              Activer le travail
            </label>
          </div>

          <div className="form-actions" style={{ marginTop: "15px" }}>
            <button className="save-work-btn" onClick={handleSubmit} disabled={!formWork.name}>
              {isEdit ? "Enregistrer les modifications" : "Ajouter le travail"}
            </button>
            <button className="cancel-work-btn" onClick={onClose}>Annuler</button>
          </div>
        </div>
      </div>
    </div>
  );
}